/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";

const ProcessCardsComponentDisplay = () => {
    const { component } = useContext(ContentZoneContext);
    const title = component?.title;
    const description = component?.description;
    const list = component?.list || [];
    
    return (
        <div className="simplicity-process-cards">
            <h2>{title}</h2>
            {description && <RichTextPreview richtext={description} />}
            <div className="simplicity-process-cards-container">
                {list.map((card, index) => (
                    <div key={index} className="simplicity-process-card">
                        <div className='process-card-heading'>
                            <h4>{card.heading}</h4>
                            <span>{card.stepNumber}</span>
                        </div>
                        {card.description && <RichTextPreview richtext={card.description} />}
                    </div>
                ))}
            </div>
        </div>
    );
};

ProcessCardsComponentDisplay.displayName = "ProcessCardsComponentDisplay";
export { ProcessCardsComponentDisplay };
